// extracted by mini-css-extract-plugin
module.exports = {"scrollBar":"ScrollBar_scrollBar__2yej8"};